import {
  type OfferPerfCtaPoint,
  type OfferPerformanceCtaReport,
  type OfferPerfV2Point,
} from '@bbkAdminRedux/rtkq/reports.slice';

export type OfferPerformanceReportRow = OfferPerfV2Point | OfferPerfCtaPoint;

export const buildOfferPerformanceCtaRows = (
  offerCtaData: OfferPerfCtaPoint[],
  offerData: OfferPerfV2Point[]
): OfferPerfCtaPoint[] => [
  ...offerCtaData.map((row) => ({
    ...row,
    totalViews: 0,
    ctaTotalViews: row.totalViews,
  })),
  ...offerData.map(
    (row) =>
      ({
        funnelAudContentCta: `${row.funnelAudContent},l_0`,
        totalViews: row.totalViews,
      }) as OfferPerfCtaPoint
  ),
];

export const getOfferPerformanceCtaRows = (
  report: Pick<OfferPerformanceCtaReport, 'offers'> | null | undefined
): OfferPerfCtaPoint[] => {
  if (!report?.offers) {
    return [];
  }

  const [offerData, offerCtaData] = report.offers;
  if (!Array.isArray(offerCtaData)) {
    return [];
  }

  return buildOfferPerformanceCtaRows(offerCtaData, offerData);
};

/** Matches play-offer-perf / offer-performance-v2 pivot export data selection. */
export const getOfferPerformanceReportRows = (
  report: Pick<OfferPerformanceCtaReport, 'offers'> | null | undefined
): OfferPerformanceReportRow[] => {
  if (!report?.offers) {
    return [];
  }

  const offerData = report.offers[0];
  const ctaRows = getOfferPerformanceCtaRows(report);

  return ctaRows.length > 0 ? ctaRows : offerData;
};
